import React from "react";
import { CtaButton } from "./CtaButton";
import { tools } from "../data/content";
export function Tools() {
  return <section className="bg-plum-50 px-5 py-16 md:py-24" data-id="element-287" data-mp="1lf41z0uum34v">
      <div className="mx-auto max-w-3xl" data-id="element-288" data-mp="17et9jtdw4ghl">
        <h2 className="text-center font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-289" data-mp="17fuwav49qrf5">
          You'll also get <em className="text-plum-600" data-id="element-290" data-mp="1cfqrq5ywhaj3">immediate access</em> to:
        </h2>

        <ul className="mt-10 divide-y divide-plum-200/70 rounded-3xl bg-white px-6" data-id="element-291" data-mp="203qszztu8jbx">
          {tools.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex items-start gap-4 py-5" data-id="element-292" data-mp="1qdfejjcj2rqs">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-plum-800 text-white" data-id="element-293" data-mp="1qd5mlq7xaaig">
                <Icon className="h-6 w-6" aria-hidden data-id="element-294" data-mp="2j232jmonvv81" />
              </span>
              <div data-id="element-295" data-mp="2j0rvndzx67cp">
                <h3 className="text-lg font-bold text-ink" data-id="element-296" data-mp="2nst6qwlcps15">{title}</h3>
                <p className="mt-1 text-[15px] leading-snug text-ink/70" data-id="element-297" data-mp="2nu49ct328tqo">{text}</p>
              </div>
            </li>)}
        </ul>

        <blockquote className="mt-10 text-center font-display text-2xl font-bold italic leading-snug text-plum-900 md:text-3xl" data-id="element-298" data-mp="2l0c8p8ntbud3">
          “Whatever implant case walks into my practice… I have a structured framework for knowing what to review, what
          to decide, and what needs to be defined before surgery.”
        </blockquote>

        <div className="mt-10" data-id="element-299" data-mp="38obvxylx12mx">
          <CtaButton label="Get access to the complete system" data-id="element-300" data-mp="38rrb11flaboc" />
        </div>
      </div>
    </section>;
}